import * as z from "zod/v4";
import { investmentListingStatusEnum } from "#backend/modules/investment-listings/investment-listings.model.js";

export const salesListingFiltersSchema = z.object({
	minPrice: z.number().nullable(),
	maxPrice: z.number().nullable(),
	status: z.string().nullable(),
	type: z.string().nullable(),
	beds: z.number().nullable(),
	baths: z.number().nullable()
});

export type SalesListingFilters = z.infer<typeof salesListingFiltersSchema>;

// Sell-side property-type filter options (the on-market parent categories, minus
// Rental / Commercial Lease). Matched against each listing's free-text
// `propertyType`. The App UI investment-listings model carries `propertyType` as text
// (no enum), so this is a static list rather than a derived enum. "Farm & Ranch"
// was dropped: no live `propertyType` row carries it (validated against the
// entity's 5 SELECT options + a DB distinct pull, see PR body).
export const sellPropertyTypes = ["Residential", "Multi-Family", "Commercial", "Land"];

export const saleListingStatuses = investmentListingStatusEnum.enumValues;
